/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropentrystatelost3Inputs */

const en_dropentrystatelost3 = /** @type {(inputs: Dropentrystatelost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost`)
};

const de_dropentrystatelost3 = /** @type {(inputs: Dropentrystatelost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gewonnen`)
};

/**
* | output |
* | --- |
* | "Lost" |
*
* @param {Dropentrystatelost3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropentrystatelost3 = /** @type {((inputs?: Dropentrystatelost3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropentrystatelost3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropentrystatelost3(inputs)
	return de_dropentrystatelost3(inputs)
});
export { dropentrystatelost3 as "dropEntryStateLost" }